import { React, useEffect, useState } from "react";
import { NavHashLink } from 'react-router-hash-link';
import { showSnackbar } from "../../../Components/Notification/Snackbar";
import ApiCaller from "../../../services/api/APICaller";
import AppIcons from "../../../assets/images/icons";
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";
import "./offplan.scss";
import { Grid } from '@mui/material';
import BlogListSlider from '../../../Components/blogRevamp/blogListSlider';
import SVGIcons from '../../../assets/images/icons/svgIcons';
import ContactPopup from '../../../Components/ContactPopup/ContactPopup';
import NewsPaperForm from '../../../Components/newsPaperForm/newsPaperForm';
import S3ImageViewerWithFallback from "../../../Components/awsS3ImageViewer/ImgViewerWithFallback";



// import DownloadBrochurePopup from '../../../Components/downloadBrochurePopup/downloadBrochurePopup';

const OffPlanProperties = () => {
  ScrollToTopOnMount();



  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  /**
  the legendary use effect function
  This will run very first on render
   */
  useEffect(() => {
    getDataArr();
  }, [])

  const getDataArr = () => {
    const apiCaller = new ApiCaller('off-plan/our-off-plans?status=active');
    apiCaller.getList().then(({ data }) => {
      setData(data.result)
    })
      .catch(() => showSnackbar().failure('Something went wrong'))
      .finally(() => setIsLoading(false));
  }


  // const OffPlanPropertyList = [
  //   {
  //     teamMemberImage: AppIcons.damacIslands,
  //     name: "I'm interested in Damac Islands...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.damacLagoons,
  //     name: "I'm interested in Damac Lagoons Mykonos...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.damacbay2,
  //     name: "I'm interested in Damac Bay2 by Cavalli...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.aziziMilan,
  //     name: "I'm interested in Azizi Milan...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.sobhaSolis,
  //     name: "I'm interested in Sobha Solis...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.emmrAlbero,
  //     name: "I'm interested in Emaar Albero...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.meraas,
  //     name: "I'm interested in Meraas Central Park Plaza...",
  //   },
  //   {
  //     teamMemberImage: AppIcons.makheel,
  //     name: "I'm interested in Nakheel Bay villas...",
  //   },

  // ];


  const TrustedDevelopers = [
    {
      devImage: AppIcons.trustedDev1,
      name: "DAMAC",
    },
    {
      devImage: AppIcons.trustedDev2,
      name: "EMAAR",
    },
    {
      devImage: AppIcons.trustedDev3,
      name: "MERAAS",
    },
    {
      devImage: AppIcons.trustedDev4,
      name: "SOBHA",
    },
    {
      devImage: AppIcons.trustedDev5,
      name: "NAKHEEL",
    },
    {
      devImage: AppIcons.trustedDev6,
      name: "ELLINGTON",
    },
    {
      devImage: AppIcons.trustedDev7,
      name: "BINGHATTI",
    },
    {
      devImage: AppIcons.trustedDev8,
      name: "DANUBE",
    },
    {
      devImage: AppIcons.trustedDev9,
      name: "AZIZI",
    },
    {
      devImage: AppIcons.trustedDev10,
      name: "SOBHA",
    },


  ];



  return (
    <div className="page-main-wrapper about-main-wrapper-1 article-main-wrapper article-revamp-wrapper offPlan-revamp-wrapper f-wrp">

      <div className="article-banner-wrp f-wrp">
        <div className="container">
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={12} md={12} lg={7}>
              <div className="banner-content-box f-wrp">
                <h1 className="main-title">Explore Dubai's Best Off-Plan Property Deals</h1>
                <p>Discover a curated selection of high-potential projects across the city. Filter by payment plans, handover dates and starting prices. From waterfront residences to investment-ready communities. Designed for buyers seeking flexibility, value, and long-term growth. Updated regularly with the latest launches and exclusive offers.</p>
                <NavHashLink className='custom-pln-btn' smooth to={'#properties'}>Let's Find Your Property</NavHashLink>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

      <div className='offPlan-content-box f-wrp'>
        <div className='why-invest-sec f-wrp'>
          <div className='container'>
            <div className='why-invest-block f-wrp'>
              <Grid container spacing={7}>
                <Grid item xs={12} sm={12} md={12} lg={5}>
                  <div className="invest-info f-wrp">
                    <h1 className="main-title">Why Invest in Dubai?</h1>
                    <p>Dubai's off-plan projects offer exceptional returns, flexible payment plans, and exclusive luxury. With unmatched infrastructure and prime location, now is the time to invest in Dubai's most promising developments.</p>

                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={7}>
                  <div className="invest-info-list f-wrp">
                    <span className='lft-img'><img src={AppIcons.burjAndFlyovers} alt='logo' /></span>
                    <ul>
                      <li><SVGIcons.GlobalVisaIcon /><p>Golden Visa opportunities.</p></li>
                      <li><SVGIcons.HighReturnIcon /><p>High rental returns.</p></li>
                      <li><SVGIcons.TaxIcon /><p>0% tax.</p></li>
                      <li><SVGIcons.InvstFrindlyVisaIcon /><p>Investor-friendly policies.</p></li>
                    </ul>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>


      {(isLoading) ? "Loading Off-Plan properties" :
        <>
          {(!isLoading && data?.length === 0) ? "No Results found" :

            <div className='offPlan-property-box f-wrp' id='properties'>
              <div className='container'>

                <Grid container spacing={5}>
                  {data?.map((element, key) => (
                    <Grid item xs={12} sm={12} md={12} lg={6} key={key}>
                      <div className="each-property-items f-wrp" key={key}>
                        {element.title ? <ContactPopup
                          defaultComment={`I'm interested in ${element.title}.. `}/> : null}
                        <span><S3ImageViewerWithFallback fileKey={element.imageURL} /></span>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </div>
            </div>
          }
        </>
      }

      <div className='offPlan-trustedDev-sec f-wrp'>
        <div className='container'>
          <div className='offPlan-section-header f-wrp'>
            <h1 className='main-title'>Our Trusted Developer Partners</h1>
            <p>We work exclusively with Dubai's most reputable real estate developers to bring you exceptional off-plan projects, world-class quality, and investment confidence.</p>
          </div>

          <div className='each-partner-wrp f-wrp'>
            <div className='each-partner-box f-wrp'>
              <ul>
                {TrustedDevelopers.map((element, key) => (
                  <li key={key}><span><img src={element.devImage} alt={element.name} /></span>
                    <p>{element.name}</p></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='free-advice-sec f-wrp'>
        <div className='container'>
          <div className='free-advice-box'>
            <div className="free-advice-content-box f-wrp">
              <Grid container spacing={5}>
                <Grid item xs={12} sm={12} md={9} lg={8}>
                  <h1 className="main-title">Free Expert Advice</h1>
                  <p>Not sure where to start? Our property consultants are here to help you make informed, confident decisions. Schedule your free consultation now and explore Dubai's top opportunities.</p>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ContactPopup title={'Book a  free consultation!'} defaultComment={'I need a free consultation!'} />
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>

      <div className='offPlan-trustedDev-sec newsPaper-block f-wrp'>
        <div className='container'>
          <div className='offPlan-section-header f-wrp'>
            <h1 className='main-title'>Be First to Know</h1>
            <p>Get insider access to Dubai's real estate scene. No fluff, just smart updates and real opportunities.</p>
          </div>

          <div className='newsPaper-blk f-wrp'>
            <NewsPaperForm />
          </div>
        </div>
      </div>

      <div className='insight-content-box f-wrp'>
        <div className='each-insight-sections f-wrp'>
          <div className='container'>
            <div className='blogListSlider f-wrp'>
              <BlogListSlider />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffPlanProperties;
